<template>
    <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">
      <van-nav-bar
            title="个人中心"
            id="topbar"
        />
      <div class="topBg">
        <div class="headImgDiv">
          <img v-if="avartarId" class="headImg" :src="apiUrl + 'download/' + avartarId" @click="showAvatar(avartarId)"/>
          <img v-else class="headImg" src="../../assets/headPortrait.png">
        </div>
      </div>
      <div class="infoDiv" @click="toUserInfo">
        <van-row type="flex" justify="space-between" align="center">
          <van-col style="display:flex;align-items:center;">
            <div class="infoText">
              <div>用户资料</div>
            </div>
          </van-col>
          <van-col>
            <img class="rightIcon" src="../../assets/right.png">
          </van-col>
        </van-row>
      </div>
      <div class="infoDiv" @click="createshow = true">
        <van-row type="flex" justify="space-between" align="center">
          <van-col style="display:flex;align-items:center;">
            <div class="infoText">
              <div>修改密码</div>
            </div>
          </van-col>
          <van-col>
            <img class="rightIcon" src="../../assets/right.png">
          </van-col>
        </van-row>
      </div>
      <div class="infoDiv2" @click="toLogout">
        <div>退出登录</div>
      </div>

      <van-action-sheet v-model="createshow" title="密码修改">
        <div class="content">
            <van-form @submit="onCreateSubmit">
                <van-field
                    v-model="oldpasswd"
                    name="旧密码"
                    label="旧密码"
                    type="password"
                    placeholder="请输入旧密码"
                    :rules="[{ required: true, message: '此项必填' }]"
                />
                <van-field
                    v-model="newpasswd"
                    name="新密码"
                    label="新密码"
                    type="password"
                    placeholder="请输入新密码"
                    :rules="[{ required: true, message: '此项必填' }]"
                />
                <van-field
                    v-model="newpasswd2"
                    name="新密码"
                    label="新密码"
                    type="password"
                    placeholder="请输入新密码"
                    :rules="[{ required: true, message: '此项必填' }]"
                />
                <div style="margin: 32px 16px 16px 16px;">
                    <van-button round block type="info" native-type="submit">
                    保存
                    </van-button>
                </div>
                </van-form>
        </div>
    </van-action-sheet>

      <van-tabbar v-model="active">
      <van-tabbar-item to="../homepage">
        <span>主页</span>
        <template #icon="props">
          <img :src="props.active ? icon.homeInActive : icon.homeActive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="../project/proList">
        <span>项目</span>
        <template #icon="props">
          <img :src="props.active ? icon.proInActive : icon.proActive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="../common/me">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? icon.meInActive : icon.meActive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
    </div>
</template>
<script>
    import $ from '@/fly'
    import { Toast, Dialog, ImagePreview } from 'vant';
    import Setting from '@/setting';
    export default {
        name: 'common-me',
        props: {
            index: {
                type: Number,
                default () {
                    return 0;
                }
            }
        },
        created () {
            // this.index = this.active;
        },
        data () {
            return {
                icon: {
                    homeInActive: require('../../assets/inHomeIcon.svg'),
                    homeActive: require('../../assets/homeIcon.svg'),
                    proInActive: require('../../assets/inProIcon.svg'),
                    proActive: require('../../assets/proIcon.svg'),
                    meInActive: require('../../assets/inMeIcon.svg'),
                    meActive: require('../../assets/meIcon.svg')
                },
                active: 2,
                clientHeight: window.screen.height,
                createshow: false,
                newpasswd: '',
                newpasswd2: '',
                oldpasswd: '',
                apiUrl: Setting.apiBaseURL,
                avartarId: ''
            }
        },
        computed: {
        },
        methods: {
            showAvatar (id) {
                ImagePreview({
                    images: [
                        Setting.apiBaseURL + 'download/' + id
                    ],
                    closeable: true
                });
            },
            onCreateSubmit () {
                if (this.oldpasswd && this.newpasswd && this.newpasswd2) {
                    if (this.newpasswd !== this.newpasswd2) {
                        Toast('二次密码输入不一致')
                    } else {
                        var that = this;
                        $.put('user/password', {
                            originalPassword: this.oldpasswd,
                            username: this.$store.state.admin.user.info.username,
                            newPassword: this.newpasswd
                        })
                            .then(res => {
                                if (res === 0) {
                                    Toast.fail('修改失败，当前密码输入错误');
                                } else {
                                    Toast.success('修改成功,请重新登录');
                                    that.createshow = false;

                                    setTimeout(function () {
                                        that.logout();
                                    }, 1500);
                                }
                                that.oldpasswd = ''
                                that.newpasswd = ''
                                that.newpasswd2 = ''
                            });
                    }
                } else {
                    Toast('请填写完整信息')
                }
            },
            toUserInfo () {
                this.$router.push({ name: 'common-userInfo' });
            },
            logout () {
                // 删除cookie
                localStorage.removeItem('token');
                localStorage.removeItem('uuid');
                localStorage.removeItem('USER');
                localStorage.removeItem('USER_ROUTER');
                localStorage.removeItem('USER_PERMISSIONS');
                this.$router.push('/login');
            },
            toLogout () {
                Dialog.confirm({
                    title: '是否退出登录'
                }).then(() => {
                    this.logout();
                })
            }
        },
        mounted () {
            this.avartarId = JSON.parse(localStorage.getItem('USER')).avatar;
        }
    }

</script>

<style lang="less" scoped>
  .topBg{
    height:500px;
    width: 100%;
    background: url(../../assets/meBg.png) no-repeat;
    background-size: 100%;
  }
  .headImgDiv{
    line-height: 400px;
    text-align: center;
  }
  .headImg{
      width: 240px;
      height: 240px;
      border-radius: 50%;
      border:15px solid #3359fa;
  }
  .infoDiv{
    background-color: #FFFFFF;
    width: 100%;
    padding: 30px;
    margin-bottom: 25px;
    border-radius: 5px;
  }
  .rightIcon{
    width: 25px;
  }
  .infoDiv2{
    background-color: #FFFFFF;
    width: 100%;
    padding: 38px;
    margin-bottom: 25px;
    border-radius: 5px;
    text-align: center;
    color: #F65B5B;
    font-weight: bold;
    font-size: 28px;
  }
</style>
